import { NgModule } from '@angular/core';
import { LibExpenditureIconComponent } from './lib-expenditure-icon.component';

@NgModule({
  declarations: [LibExpenditureIconComponent],
  imports: [],
  exports: [LibExpenditureIconComponent],
})
export class LibExpenditureIconModule {}
